import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Alert} from "reactstrap";

export function DromWarningBanner() {
  return (
    <Alert color="warning" className="d-flex align-items-start gap-2">
      <FontAwesomeIcon icon="exclamation-triangle" className="mt-1" />
      <div>
        <strong>Département d'outre-mer détecté.</strong>
        <p className="mb-0">
          Les taux de TVA applicables dans votre département (8,5 / 2,1 / 1,75 / 1,05 % pour la
          Guadeloupe, la Martinique et La Réunion ; TVA non applicable pour la Guyane et Mayotte)
          ne sont pas encore pris en charge par cette fonctionnalité. Vos factures pourraient ne
          pas refléter le bon taux. Contactez-nous pour adapter votre configuration.
        </p>
      </div>
    </Alert>
  );
}
